import React from "react";
export class OrganizationSelector extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="organization_selector">
                    {/* <label htmlFor="my-organizations">My Organizations</label> */}
                    <select onChange={this.props.valueSelected} defaultValue={this.props.initialValue}>
                        <option value="">My Profile</option>
                        {
                            Object.keys(this.props.organizationList).map((key:any, i:number) => (
                                <option 
                                    key={key} 
                                    value={key}
                                >
                                    {this.props.organizationList[key].org_name}
                                </option>
                            ))
                        }
                    </select>
                </div>
            </div>
        )
    }
}